// extracted by mini-css-extract-plugin
export default {"globalsLineChart":"GlobalsLineChart_globalsLineChart__heuFn","yearSelector":"GlobalsLineChart_yearSelector__tJchp","empty":"GlobalsLineChart_empty__K45aC"};